module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2BAMAAAB+a3fuAAAALVBMVEVUZn9SZH1SZH0KERwFDRdVZ4FXaYNAT2QcJjVSZH4CCBJNX3dEVGtFVGorN0iBz6HtAAAAA3RSTlPu+N7kBK0SAAAAbUlEQVQ4y2NQYMAFmBgkZ4alYQOpMycyzJwZih3MnMnAOft4OTZQs3MCA2vsiw5soO9qAANbeMsSF0zg5VGaAJTrwiq3AizX4myMCUw8RuVG5UblRuUokCNQ9uArs/CVdfjKSHxlK74yGV9ZDgBGonrYXW6YdgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/images/checkbox_bg.png
// module id = KBsf
// module chunks = 1